import { Box } from '@palmetto/palmetto-components';
import { DateTime } from 'luxon';

import EventBy from './EventBy';

const OneTimePaymentScheduled = ({ event }: { event: any }) => {
  const { amount, paymentDate, paymentType } = event.data;
  const label = paymentType === 'ach' ? 'ACH' : 'credit card';

  return (
    <Box display="block">
      <Box as="span" display="inline-block" margin="0 2xs 0 0">
        <EventBy event={event} /> scheduled a one-time {label} payment
        {amount !== undefined && (
          <>
            {' '}
            of <strong>${Number(amount).toFixed(2)}</strong>
          </>
        )}
        {paymentDate && (
          <>
            {' '}
            for <strong>{DateTime.fromISO(paymentDate).toLocaleString(DateTime.DATE_MED)}</strong>
          </>
        )}
      </Box>
    </Box>
  );
};

export default OneTimePaymentScheduled;
